import React, { useContext, useState } from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NonIconButton from "../../../../components/NonIconButton";
import { recruitmentRegistrationContext } from "../../RecruitmentRegistationPage";
import { SmallHeadline, NormalText } from "../../../../components/TextParts";
import BaseApi from "../../../../functions/axios";
import RegistrationSuccessful from "../molecules/RegistrationSuccessful";
import RegistrationFailed from "../molecules/RegistrationFailed";
const PROJECT_TYPE_TEXT = {
  1: "開発",
  2: "インフラ",
  3: "その他（コンサル、セキュリティ、デザイン、等その他）",
};

export default function ConfirmationModal() {
  const {
    isModalOpen,
    setIsModalOpen,
    mailBody,
    mailSubject,
    setMailBody,
    setMailSubject,
    projectType,
    setProjectType,
    requiredSkill,
    setRequiredSkill,
  } = useContext(recruitmentRegistrationContext);

  const [isRegistrationSuccessful, setIsRegistrationSuccessful] = useState(false);
  const [isRegistrationFailed, setIsRegistrationFailed] = useState(false);
  const [message, setMessage] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const modalWidth =
    isRegistrationSuccessful || isRegistrationFailed
      ? { xs: "90vw", sm: "300px" }
      : { xs: "90vw", sm: "600px" };

  const handleClose = () => {
    setIsModalOpen(false);
    setIsRegistrationFailed(false);
    setIsRegistrationSuccessful(false);
    setMessage(null);
  };

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);

    const formData = new FormData();
    formData.append("mail_subject", mailSubject);
    formData.append("mail_body", mailBody);
    formData.append("project_type", projectType);
    formData.append("required_skill", requiredSkill);

    try {
      const res = await BaseApi.post("regist_project", formData);
      if (res?.data?.result === 9) {
        setMessage(res.data.message);
        setIsRegistrationFailed(true);
      } else {
        setIsRegistrationSuccessful(true);
        setMailBody("");
        setMailSubject("");
        setRequiredSkill("");
        setProjectType(null);
      }
    } catch (err) {
      console.error("regist_project error:", err);
      setIsRegistrationFailed(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal open={isModalOpen} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: modalWidth,
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          px: "20px",
          pb: "20px",
        }}
      >
        {isRegistrationSuccessful ? (
          <RegistrationSuccessful handleClose={handleClose} />
        ) : isRegistrationFailed ? (
          <RegistrationFailed handleClose={handleClose} message={message} />
        ) : (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ flexGrow: 1 }}>
                <SmallHeadline text="件名" />
              </Box>
              <IconButton
                sx={{ width: "30px", height: "30px", mt: "10px" }}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                height: "30px",
                overflowY: "auto",
                overflowWrap: "break-word",
                border: 1,
                borderColor: "#ddd",
                p: "5px",
              }}
            >
              <NormalText text={mailSubject} />
            </Box>

            <SmallHeadline text="募集種別" />
            <Box
              sx={{
                overflowWrap: "break-word",
                border: 1,
                borderColor: "#ddd",
                p: "5px",
              }}
            >
              <NormalText text={PROJECT_TYPE_TEXT[projectType] || ""} />
            </Box>

            <SmallHeadline text="必須スキル" />
            <Box
              sx={{
                height: "80px",
                overflowY: "auto",
                overflowWrap: "break-word",
                border: 1,
                borderColor: "#ddd",
                p: "5px",
              }}
            >
              <NormalText text={requiredSkill} />
            </Box>

            <SmallHeadline text="本文" />
            <Box
              sx={{
                height: "300px",
                overflowY: "auto",
                overflowWrap: "break-word",
                border: 1,
                borderColor: "#ddd",
                p: "5px",
              }}
            >
              <NormalText text={mailBody} />
            </Box>

            <Box sx={{ my: "20px" }}>
              <NonIconButton
                title="募集登録"
                clickEvent={handleSubmit}
                disabled={!mailBody || !mailSubject || submitting}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
}